//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import OrdenesAPI from '@/api/promotores/ordenes.api'
import TareaEditDialog from './TareaEditDialog.vue'

export default {
  data() {
    return {
      columns: [
        { name: 'id', field: '_id', label: 'ID', style: "width: 10px" },
        { 
          name: 'prospecto', 
          field: 'prospecto', 
          label: 'Prospecto', 
          sortable: true, 
          align: 'left', 
          classes: "bg-grey-2 ellipsis",
          headerClasses: "bg-primary text-white",
        },
        { name: 'promotor', field: 'usuario', label: 'Promotor', sortable: true, align: 'left', },
        { name: 'organizacion', field: 'organizacion', label: 'Organización', sortable: true, align: 'left', },
        { name: 'status', field: 'status', label: 'Status', align: 'left', sortable: true, },
        { name: 'created_at', field: 'created_at', label: 'Creación', align: 'left', sortable: true, },
      ],
      tareas: [],
      loading: true
    }
  },

  mounted() {
    this.loadTareas()
  },

  methods: {
    async loadTareas() {
      try {
        this.loading = true
        this.tareas = await OrdenesAPI.all({ organizaciones: 'sadasi,skypark,ihm' })
      } finally {
        this.loading = false
      }
    },

    editTarea(tarea) {
      const dialog = this.$q.dialog({
        component: TareaEditDialog,
        tarea
      })

      dialog.onOk((tarea) => {
        this.loadTareas()
      })
    }
  }
}
